module.exports = __webpack_public_path__ + "static/media/EI.86037010.png";